<template>
  <div>
     <v-textarea
          name="input-7-1"
          :label="label"
          :value="defaultValue"
          :hint="hint"
          :outlined="outlined"
          :filled="filled"
           :background-color="backgroundColor"
         :color="color"
         @change="getTextContent"
         :clearable="clearable"
      :clear-icon="icon"
        ></v-textarea>
  </div>
</template>

<script>
export default {
    props:{
        label:{
            default:"Default style"
        },
        defaultValue:{
            default:''
        },
        hint:{
            default:"Hint text"
        },
        outlined:{
            default:false
        },
        filled:{
            default:false
        },
        color:{
            default:"cyan"
        },
        clearable:{
            default:false
        },
        icon:{
            default:"mdi-delete"
        },
        backgroundColor:{
            default: "grey lighten-2"
        }
    },
    methods:{
        getTextContent(content){
            this.$emit('get-content',content)
        }
    }

}
</script>

<style>

</style>